import dayjs from "dayjs";

import {
    CREATE_DATA_SYNDICATION_SOURCE_FAILURE,
    CREATE_DATA_SYNDICATION_SOURCE_REQUEST,
    CREATE_DATA_SYNDICATION_SOURCE_SUBSCRIPTION_FAILURE,
    CREATE_DATA_SYNDICATION_SOURCE_SUBSCRIPTION_REQUEST,
    CREATE_DATA_SYNDICATION_SOURCE_SUBSCRIPTION_SUCCESS,
    CREATE_DATA_SYNDICATION_SOURCE_SUCCESS,
    DELETE_DATA_SYNDICATION_SOURCE_FAILURE,
    DELETE_DATA_SYNDICATION_SOURCE_REQUEST,
    DELETE_DATA_SYNDICATION_SOURCE_SUCCESS,
    GET_DATA_SYNDICATION_SOURCE_FAILURE,
    GET_DATA_SYNDICATION_SOURCE_LIST_FAILURE,
    GET_DATA_SYNDICATION_SOURCE_LIST_REQUEST,
    GET_DATA_SYNDICATION_SOURCE_LIST_SUCCESS,
    GET_DATA_SYNDICATION_SOURCE_REQUEST,
    GET_DATA_SYNDICATION_SOURCE_SUBSCRIPTION_LIST_FAILURE,
    GET_DATA_SYNDICATION_SOURCE_SUBSCRIPTION_LIST_REQUEST,
    GET_DATA_SYNDICATION_SOURCE_SUBSCRIPTION_LIST_SUCCESS,
    GET_DATA_SYNDICATION_SOURCE_SUCCESS,
    UPDATE_DATA_SYNDICATION_SOURCE_FAILURE,
    UPDATE_DATA_SYNDICATION_SOURCE_REQUEST,
    UPDATE_DATA_SYNDICATION_SOURCE_SUCCESS,
} from "./actions";

import { DELETE_DATA_SYNDICATION_SUBSCRIPTION_SUCCESS } from "../dataSyndicationSubscription/actions";

import { ActionStatus } from "common/enums";

const initialState = {
    getDataSyndicationSourceListAction: {
        status: ActionStatus.NONE,
    },
    dataSyndicationSourceList: {
        Items: [],
    },
    getDataSyndicationSourceAction: {
        status: ActionStatus.NONE,
    },
    source: null,
    createDataSyndicationSourceAction: {
        status: ActionStatus.NONE,
    },
    createdSource: null,
    updateDataSyndicationSourceAction: {
        status: ActionStatus.NONE,
    },
    deleteDataSyndicationSourceAction: {
        status: ActionStatus.NONE,
    },
    createDataSyndicationSourceSubscriptionAction: {
        status: ActionStatus.NONE,
    },
    getDataSyndicationSourceSubscriptionListAction: {
        status: ActionStatus.NONE,
    },
    subscriptionListResult: {
        sourceId: null,
        Items: [],
    },
    newSourceSubscriptionAction: {},
};

export default (state = initialState, action) => {
    let dataSyndicationSourceList = {
        Items: [],
    };
    let sourceIndex = -1;
    switch (action.type) {
        case GET_DATA_SYNDICATION_SOURCE_LIST_REQUEST:
            return { ...state, getDataSyndicationSourceListAction: { status: ActionStatus.PENDING } };
        case GET_DATA_SYNDICATION_SOURCE_LIST_SUCCESS:
            return { ...state, getDataSyndicationSourceListAction: { status: ActionStatus.SUCCESS }, dataSyndicationSourceList: action.payload.result };
        case GET_DATA_SYNDICATION_SOURCE_LIST_FAILURE:
            return { ...state, getDataSyndicationSourceListAction: { status: ActionStatus.FAILED, ...action.payload.error }, dataSyndicationSourceList: { Items: [] } };

        case GET_DATA_SYNDICATION_SOURCE_REQUEST:
            return { ...state, getDataSyndicationSourceAction: { status: ActionStatus.PENDING }, source: null };
        case GET_DATA_SYNDICATION_SOURCE_SUCCESS:
            if (action.payload.source) {
                if (action.payload.source.validFrom) {
                    action.payload.source.validFrom = dayjs(action.payload.source.validFrom);
                }

                if (action.payload.source.validUntil) {
                    action.payload.source.validUntil = dayjs(action.payload.source.validUntil);
                }
            }
            return { ...state, getDataSyndicationSourceAction: { status: ActionStatus.SUCCESS }, source: action.payload.source };
        case GET_DATA_SYNDICATION_SOURCE_FAILURE:
            return { ...state, getDataSyndicationSourceAction: { status: ActionStatus.FAILED, ...action.payload.error }, source: null };

        case CREATE_DATA_SYNDICATION_SOURCE_REQUEST:
            return { ...state, createDataSyndicationSourceAction: { status: ActionStatus.PENDING }, createdSource: null };
        case CREATE_DATA_SYNDICATION_SOURCE_SUCCESS:
            dataSyndicationSourceList = { ...state.dataSyndicationSourceList };
            dataSyndicationSourceList.Items = [...dataSyndicationSourceList.Items];
            dataSyndicationSourceList.Items.push(action.payload.source);
            return { ...state, createDataSyndicationSourceAction: { status: ActionStatus.SUCCESS }, createdSource: action.payload.source };
        case CREATE_DATA_SYNDICATION_SOURCE_FAILURE:
            return { ...state, createDataSyndicationSourceAction: { status: ActionStatus.FAILED, ...action.payload.error }, createdSource: null };

        case UPDATE_DATA_SYNDICATION_SOURCE_REQUEST:
            return { ...state, updateDataSyndicationSourceAction: { status: ActionStatus.PENDING } };
        case UPDATE_DATA_SYNDICATION_SOURCE_SUCCESS:
            dataSyndicationSourceList = state.dataSyndicationSourceList;
            if (action.payload.source) {
                sourceIndex = dataSyndicationSourceList.Items.findIndex((item) => item.sourceId === action.payload.source.sourceId);
                if (sourceIndex > -1) {
                    dataSyndicationSourceList = { ...dataSyndicationSourceList };
                    dataSyndicationSourceList.Items = [...dataSyndicationSourceList.Items];
                    dataSyndicationSourceList.Items[sourceIndex] = action.payload.source;
                }
            }
            return { ...state, updateDataSyndicationSourceAction: { status: ActionStatus.SUCCESS }, dataSyndicationSourceList };
        case UPDATE_DATA_SYNDICATION_SOURCE_FAILURE:
            return { ...state, updateDataSyndicationSourceAction: { status: ActionStatus.FAILED, ...action.payload.error } };

        case DELETE_DATA_SYNDICATION_SOURCE_REQUEST:
            return { ...state, deleteDataSyndicationSourceAction: { status: ActionStatus.PENDING } };
        case DELETE_DATA_SYNDICATION_SOURCE_SUCCESS:
            dataSyndicationSourceList = { ...state.dataSyndicationSourceList };
            dataSyndicationSourceList.Items = state.dataSyndicationSourceList.Items.filter((item) => item.sourceId !== action.payload.sourceId);
            return { ...state, deleteDataSyndicationSourceAction: { status: ActionStatus.SUCCESS }, dataSyndicationSourceList };
        case DELETE_DATA_SYNDICATION_SOURCE_FAILURE:
            return { ...state, deleteDataSyndicationSourceAction: { status: ActionStatus.FAILED, ...action.payload.error } };

        case CREATE_DATA_SYNDICATION_SOURCE_SUBSCRIPTION_REQUEST:
            return {
                ...state,
                newSourceSubscriptionAction: { ...state.newSourceSubscriptionAction, [action.params.subscription.subscriptionKey]: { status: ActionStatus.PENDING, error: null } },
            };
        case CREATE_DATA_SYNDICATION_SOURCE_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                newSourceSubscriptionAction: {
                    ...state.newSourceSubscriptionAction,
                    [action.payload.subscription.subscriptionKey]: { status: ActionStatus.SUCCESS, error: null, subscription: action.payload.subscription },
                },
            };
        case CREATE_DATA_SYNDICATION_SOURCE_SUBSCRIPTION_FAILURE:
            return {
                ...state,
                newSourceSubscriptionAction: {
                    ...state.newSourceSubscriptionAction,
                    [action.payload.subscription.subscriptionKey]: { status: ActionStatus.FAILED, error: action.payload.error },
                },
            };
        case GET_DATA_SYNDICATION_SOURCE_SUBSCRIPTION_LIST_REQUEST:
            return {
                ...state,
                getDataSyndicationSourceSubscriptionListAction: { status: ActionStatus.PENDING },
                subscriptionListResult: { Items: [], sourceId: action.params.sourceId },
                newSourceSubscriptionAction: {},
            };
        case GET_DATA_SYNDICATION_SOURCE_SUBSCRIPTION_LIST_SUCCESS:
            const subscriptionList = action.payload.result.Items.map((item) => ({
                ...item,
                subscriptionKey: item.subscriptionId,
            }));
            return {
                ...state,
                getDataSyndicationSourceSubscriptionListAction: { status: ActionStatus.SUCCESS },
                subscriptionListResult: { ...action.payload.result, sourceId: action.payload.sourceId, Items: subscriptionList },
            };
        case GET_DATA_SYNDICATION_SOURCE_SUBSCRIPTION_LIST_FAILURE:
            return {
                ...state,
                getDataSyndicationSourceSubscriptionListAction: { status: ActionStatus.FAILED, ...action.payload.error },
                subscriptionListResult: { Items: [], sourceId: action.payload.sourceId },
            };

        case DELETE_DATA_SYNDICATION_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                subscriptionListResult: {
                    ...state.subscriptionListResult,
                    Items: state.subscriptionListResult.Items.filter((item) => item.subscriptionId !== action.payload.subscriptionId),
                },
            };

        default:
            return state;
    }
};
